module.exports = __webpack_public_path__ + "static/media/healthcare.79bbc3ad.png";